export default __webpack_public_path__ + "static/media/you_can_do_it.25b0427a.svg";